import * as React from 'react';
import logo from './assets/logo.svg';
import user from './assets/user.svg';
import LayoutManager from './LayoutManager';
import Button from './components/Button';
import StyleSheet from './StyleSheet';
import { Link } from './router';

// const template = {
//   normal: {
//     mainMenuButtonHeight: 35,
//     secondaryMenuButtonHeight: 35,
//     logoHeight: 25,
//   },
//   compact: {
//     mainMenuButtonHeight: 47,
//     secondaryMenuButtonHeight: 30,
//     logoHeight: 18
//   }
// }

export default class Header extends React.Component {
  componentWillMount() {
    window.addEventListener('repeatLayoutChange', this.onLayoutChange);
  }

  componentWillUnmount() {
    window.removeEventListener('repeatLayoutChange', this.onLayoutChange);
  }

  render() {
    console.log('render', location.pathname);
    const layout = LayoutManager.shared.layout;
    const name = localStorage.getItem('name');

    const logoComp = <div style={{ minWidth: 200 }}><Link href="/"><img key="logo" src={logo} width="80" height="18" alt={process.env.REACT_APP_REPEAT_TITLE} /></Link></div>
    const buttonStyle = (layout === 'normal' ? { height: 35 } : undefined)
    const nameButtonComp = (
      <Button
        key="nameButton"
        href="/profile"
        style={{
          ...buttonStyle,
          marginTop: -6,
          backgroundColor: location.pathname === '/profile' ? '#96d7da' : undefined
        }}
      >
        Hello,&nbsp;<img src={user} width="13" height="18" alt={name || 'user'} />&nbsp;<strong>{name}!</strong>
      </Button>
    )
    const liStyle: React.CSSProperties = { width: layout === 'normal' ? 120 : '50%' }
    const mainNavComp = (
      <ul
        style={{
          ...styles.nav,
          paddingLeft: layout === 'normal' ? 0 : 15,
          paddingRight: layout === 'normal' ? 0 : 15,
        }}
      >
        <li
          style={{
            ...liStyle,
            marginRight: 10
          }}
        >
          <Button
            href="/tasks"
            style={{
              ...tasksLinkStyle(),
              ...buttonStyle
            }}
          >
            Tasks
        </Button>
        </li>
        <li style={liStyle}>
          <Button
            href="/time/track"
            style={{
              ...linkStyle(['/time/track', '/time/list']),
              ...buttonStyle
            }}
          >
            Time
        </Button>
        </li>
      </ul >
    )

    switch (layout) {
      case 'compact':
        return (
          <React.Fragment>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                width: '100%',
                paddingTop: 17,
                paddingBottom: 10,
                boxSizing: 'border-box',
                backgroundColor: '#FFFFFF',
                paddingLeft: 15,
                paddingRight: 15
              }}
            >
              {logoComp}
              {name ? nameButtonComp : <span>&nbsp;</span>}
            </div>
            {mainNavComp}
          </React.Fragment>
        )
      case 'normal':
        return (
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              alignItems: 'center',
              width: '100%',
              paddingTop: 17,
              paddingBottom: 10,
              boxSizing: 'border-box',
              backgroundColor: '#FFFFFF',
              paddingLeft: 15,
              paddingRight: 15,
              maxWidth: 1280
            }}
          >
            {logoComp}
            {mainNavComp}
            {name ? nameButtonComp : <span>&nbsp;</span>}
          </div>
        )
    }
  }

  onLayoutChange = () => {
    console.log('onLayoutChange');
    this.forceUpdate();
  }
}

function tasksLinkStyle() {
  const path = location.pathname
  if (path === '/tasks' || (path !== '/time/track' && path !== '/time/list' && path !== '/profile')) {
    return {
      backgroundColor: '#96d7da'
    };
  }
  return undefined;
}

function linkStyle(route: string | string[]) {
  const routes = route instanceof Array ? route : [route]
  for (const r of routes) {
    if (r === location.pathname) {
      return {
        backgroundColor: '#96d7da'
      };
    }
  }
  return undefined;
};

const styles: StyleSheet = {
  nav: {
    listStyleType: 'none',
    margin: 0,
    padding: 0,
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    boxSizing: 'border-box'
  }
}



// WEBPACK FOOTER //
// ./src/Header.tsx